/**
 * ChatChannelListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatChannelListReq
 */
export interface ChatChannelListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 频道类型 */
  type?: string
  /** 频道ID */
  id?: string
  /** 频道CID */
  cid?: string
  /** 创建者ID */
  created_by_id?: any
  /** 关联群组ID */
  group_id?: any
  /** 频道类型列表 */
  type__in?: string[]
  /** 创建者ID列表 */
  created_by_id__in?: any
  /** 是否冻结 */
  frozen?: boolean
  /** 是否禁用 */
  disabled?: boolean
  /** 最小成员数 */
  member_count__gte?: number
  /** 最大成员数 */
  member_count__lte?: number
}

/**
 * ChatChannelListReq Schema
 */
export const ChatChannelListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    type: {
      description: '频道类型',
      format: '*cons.ChatChannelType',
      type: 'string',
      label: '频道类型',
    },
    id: {
      description: '频道ID',
      format: 'string',
      type: 'string',
      label: '频道ID',
    },
    cid: {
      description: '频道CID',
      format: 'string',
      type: 'string',
      label: '频道CID',
    },
    created_by_id: {
      description: '创建者ID',
      format: 'string',
      type: 'user',
      label: '创建者ID',
    },
    group_id: {
      description: '关联群组ID',
      format: 'string',
      type: 'group',
      label: '关联群组ID',
    },
    type__in: {
      description: '频道类型列表',
      format: '[]cons.ChatChannelType',
      items: {
        format: 'cons.ChatChannelType',
        type: 'string',
      },
      type: 'array',
      label: '频道类型列表',
    },
    created_by_id__in: {
      description: '创建者ID列表',
      format: '[]string',
      type: 'user',
      label: '创建者ID列表',
    },
    frozen: {
      description: '是否冻结',
      format: '*bool',
      type: 'boolean',
      label: '是否冻结',
    },
    disabled: {
      description: '是否禁用',
      format: '*bool',
      type: 'boolean',
      label: '是否禁用',
    },
    member_count__gte: {
      description: '最小成员数',
      format: '*int',
      type: 'integer',
      label: '最小成员数',
    },
    member_count__lte: {
      description: '最大成员数',
      format: '*int',
      type: 'integer',
      label: '最大成员数',
    },
  },
  type: 'object',
}
